export default __webpack_public_path__ + "static/media/m_engineering_card12_2.7a8b84e7.png";